import {Box} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import React from 'react'

import {RoleUpmPlantLookupChip} from '../../../components/Role/deprecated/RoleUpmPlantLookupChip'
import {GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'

const useStyles = makeStyles(() => ({
  deleteButton: {
    minWidth: 'auto'
  },
  container: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#7F9BA6',
    borderRadius: '3px',
    marginTop: '5px',
    padding: '6px 6px 6px 8px',
    marginBottom: '-1px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
}))

interface Props {
  groupedRoleAssignment: GroupedRoleAssignment
}

export const UpmPlants: React.FC<Props> = ({groupedRoleAssignment}) => {
  const classes = useStyles()

  const {upmIds} = groupedRoleAssignment.commonDataScopes

  if (!upmIds || upmIds.length === 0) {
    return null
  }

  return (
    <Box>
      <Box>
        {Array.isArray(upmIds) &&
          upmIds.map((upmId) => (
            <Box key={upmId} className={classes.container}>
              <RoleUpmPlantLookupChip key={upmId} upmId={upmId} />
            </Box>
          ))}
      </Box>
    </Box>
  )
}
